import { IStreamDeclaration } from '@infotech-soe/merps/types/streams';
import {
  ActionName,
  ActionProcessMode,
  THotKey,
} from '@infotech-soe/metaschema';

import { TActionArgsValues } from '../../../infrastructure/providers/abstract/IApiProvider';
import MerpsApiProvider from '../../../infrastructure/providers/pb-adapter/MerpsApiProvider';
import { downloadFileFromBlob } from '../../common/files';
import { ClientContext } from '../../context/IContextService';
import { TCommandResult } from '../types';
import { UserInteractor } from '../UserInteractor';
import { RefreshStrategy } from '../wrap/CategoryCommand';

import CategoryCommandImpl from './CategoryCommandImpl';
import RunActionCommandImpl from './RunActionCommandImpl';

class DownloadCommandImpl extends CategoryCommandImpl<TActionArgsValues> {
  constructor(private runActionCommand: RunActionCommandImpl) {
    super();
  }

  public async execute(
    context: ClientContext,
    args: TActionArgsValues
  ): Promise<TCommandResult> {
    const executeResult = await this.runActionCommand.execute(context, args);
    if (executeResult) {
      await this.download(executeResult.actionResult ?? executeResult);
      return executeResult;
    }
  }

  public getUserInteractor(): UserInteractor {
    return this.runActionCommand.getUserInteractor();
  }

  public async getInitialArgs(
    context: ClientContext
  ): Promise<TActionArgsValues> {
    return this.runActionCommand.getInitialArgs(context);
  }

  public getHotKey(): THotKey | undefined {
    return this.runActionCommand.getHotKey();
  }

  public getName(): ActionName {
    return this.runActionCommand.getName();
  }

  public getProcessMode(): ActionProcessMode {
    return this.runActionCommand.getProcessMode() || 'Sequential';
  }

  public getRefreshStrategy(): RefreshStrategy {
    return this.runActionCommand.getRefreshStrategy();
  }

  private async download(result: {
    data: IStreamDeclaration;
    fileName: string;
  }): Promise<void> {
    const buffer = await new MerpsApiProvider().streams.read(result.data.id);
    downloadFileFromBlob(result.fileName, buffer);
  }
}

export default DownloadCommandImpl;
